import { render, staticRenderFns } from "./RoomUsersTag.vue?vue&type=template&id=082c6732&"
import script from "./RoomUsersTag.vue?vue&type=script&lang=js&"
export * from "./RoomUsersTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports